var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('label',{attrs:{"for":_vm.uuid}},[_vm._v(_vm._s(this.title)+" ")]),_c('div',{attrs:{"id":_vm.uuid}})])}
var staticRenderFns = []

export { render, staticRenderFns }